import axiosInstance from '../plugin/axios';

interface FetchReportParams {
  startDate: string;
  endDate: string;
  offset?: number;
  limit?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
  name?: string;
  reportType?: string;
}

interface ReportDto {
  id: number; // 리포트 ID
  arrivedAt: string; // 도착 날짜
  name: string; // 회사 이름
  dayType: string; // 작업 유형 (반일, 하루 등)
  reportType: string; // 리포트 유형 (belonged 등)
}

interface CompanyReportDto {
  totalAmount: number; // 총 금액
  reports: ReportDto[]; // 리포트 배열
}

interface RegistrationReportbelongedDto {
  corporationId: number; // 회사 아이디
  arrivedAt: string; // 도착시
  halfDayAmount: number; // 반일 금액
  fullDayAmount: number; // 전일 금액
  goWorkTime: string; // 출근 시간
  leaveWorkTime: string; // 퇴근 시간
  dayType: string; // 작업 형태
  ryubeiVolume?: number; // 루베량 (optional)
  cycleVolume?: number; // 회전수 (optional)
  workAmount: number; // 작업 금액
  ausAmount?: number; // 요소수 금액 (optional)
  ausVolume?: number; // 요소수 주유량 (optional)
  refuelingAmount?: number; // 주유 가격 (optional)
  refuelingVolume?: number; // 주유량 (optional)
  operationDistance?: number; // 운행 거리 (optional)
  additionAmount?: number; // 추가 작업 금액 (optional)
  additionComment?: string; // 추가 작업 내용 (optional)
  totalAmount: number; // 총 수입 금액
}

interface RegistrationReportRentDto {
  ryubeiAmount: number; // 루베 금액 (필수)
  cycleAmount: number; // 회전 금액 (필수)
  freshWaterAmount?: number; // 청수 금액 (선택)
  wasteWaterAmount: number; // 폐수 금액 (필수)
  delayAmount: number; // 지연 금액 (필수)
  corporationId: number; // 회사 아이디 (필수)
  arrivedAt: string; // 도착 시 (필수)
  goWorkTime: string; // 출근 시간 (필수)
  leaveWorkTime: string; // 퇴근 시간 (필수)
  dayType: string; // 작업 형태 (필수)
  ryubeiVolume?: number; // 루베량 (선택)
  cycleVolume?: number; // 회전수 (선택)
  operationAmount: number; // 운반비 (필수)
  freshWaterVolume?: number; // 청수 횟수 (선택)
  wasteWaterVolume?: number; // 폐수 횟수 (선택)
  delayVolume?: number; // 지연 횟수 (선택)
  lkmStandard?: number; // L/KM 기준값 (선택)
  lkmAmount?: number; // L/KM 기준 금액 (선택)
  lkmDistance?: number; // L/KM 거리 (선택)
  kmlStandard?: number; // KM/L 기준값 (선택)
  kmlAmount?: number; // KM/L 기준 금액 (선택)
  kmlDistance?: number; // KM/L 거리 (선택)
  ausAmount?: number; // 요소수 금액 (선택)
  ausVolume?: number; // 요소수 주유량 (선택)
  refuelingAmount?: number; // 주유 가격 (선택)
  refuelingVolume?: number; // 주유량 (선택)
  additionAmount?: number; // 추가 작업 금액 (선택)
  additionComment?: string; // 추가 작업 내용 (선택)
  totalAmount: number; // 총 수입 금액 (필수)
}

interface ReportbelongedDetailDto {
  companyId: number; // 회사 아이디
  corporationId: number; // 회사 아이디
  arrivedAt: string; // 도착시
  halfDayAmount: number; // 반일 금액
  fullDayAmount: number; // 전일 금액
  goWorkTime: string; // 출근 시간
  leaveWorkTime: string; // 퇴근 시간
  dayType: string; // 작업 형태
  ryubeiVolume?: number; // 루베량 (optional)
  cycleVolume?: number; // 회전수 (optional)
  workAmount: number; // 작업 금액
  ausAmount?: number; // 요소수 금액 (optional)
  ausVolume?: number; // 요소수 주유량 (optional)
  refuelingAmount?: number; // 주유 가격 (optional)
  refuelingVolume?: number; // 주유량 (optional)
  operationDistance?: number; // 운행 거리 (optional)
  additionAmount?: number; // 추가 작업 금액 (optional)
  additionComment?: string; // 추가 작업 내용 (optional)
  totalAmount: number; // 총 수입 금액
  id: number; // 일보 아이디
  name: string; // 회사 이름
}

interface ReportRentDetailDto {
  ryubeiAmount: number; // 루베 금액
  cycleAmount: number; // 회전 금액
  freshWaterAmount: number; // 청수 금액
  wasteWaterAmount: number; // 폐수 금액
  delayAmount: number; // 지연 금액
  companyId: number; // 회사 아이디
  corporationId: number; // 회사 아이디
  arrivedAt: string; // 도착시
  goWorkTime: string; // 출근 시간
  leaveWorkTime: string; // 퇴근 시간
  dayType: string; // 작업 형태
  ryubeiVolume: number; // 루베량
  cycleVolume: number; // 회전수
  operationAmount: number; // 운반비
  freshWaterVolume: number; // 청수 횟수
  wasteWaterVolume: number; // 폐수 횟수
  delayVolume: number; // 지연 횟수
  lkmStandard: number; // L/KM 기준값
  lkmAmount: number; // L/KM 기준 금액
  lkmDistance: number; // L/KM 거리
  kmlStandard: number; // KM/L 기준값
  kmlAmount: number; // KM/L 기준 금액
  kmlDistance: number; // KM/L 거리
  ausAmount: number; // 요소수 금액
  ausVolume: number; // 요소수 주유량
  refuelingAmount: number; // 주유 가격
  refuelingVolume: number; // 주유량
  additionAmount: number; // 추가 작업 금액
  additionComment: number; // 추가 작업 내용
  totalAmount: number; // 총 수입 금액
  id: number; // 일보 아이디
  name: string; // 회사 이름
}

interface CorporationDto {
  corporationId: number;
  corporationName: string;
}

interface ServerResponse {
  statusCode: number;
  message: string;
}

// TransactionItemDto 인터페이스
interface TransactionItemDto {
  arrivedAt: string;
  dayType: string;
  amount: number;
  tax: number;
  note?: string;
}

// TransactionReportDtoRx 인터페이스
interface TransactionReportDtoRx {
  name: string; // 기업명
  today: string; // 오늘 날짜 (ISO 8601 형식)
  totalAmount: number; // 합계 금액
  transactions: TransactionItemDto[]; // TransactionItemDto 배열
}

export const fetchReportList = async (
  params: FetchReportParams,
): Promise<CompanyReportDto> => {
  try {
    const {
      startDate,
      endDate,
      offset = 0,
      limit = 1000,
      sortBy = 'arrivedAt',
      order = 'desc',
      name,
      reportType,
    } = params;
    const response = await axiosInstance.get<CompanyReportDto>(`/api/report`, {
      params: {
        startDate,
        endDate,
        offset,
        limit,
        sortBy,
        order,
        name,
        reportType,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const getCorporationList = async (): Promise<CorporationDto[]> => {
  try {
    const response = await axiosInstance.get<CorporationDto[]>(
      `/api/report/corporationlist`,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const reportsRegistraionBelonged = async (
  datas: RegistrationReportbelongedDto,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.post<ServerResponse>(
      `/api/report/registration/belonged`,
      datas,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const reportUpdateBelonged = async (
  reportId: number,
  datas: RegistrationReportbelongedDto,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.put<ServerResponse>(
      `/api/report/registration/belonged/edit/${reportId}`,
      datas,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const reportBelongedDetail = async (
  reportId: number,
): Promise<ReportbelongedDetailDto> => {
  try {
    const response = await axiosInstance.get<ReportbelongedDetailDto>(
      `/api/report/registartion/belonged/${reportId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const reportRegistrationRent = async (
  datas: RegistrationReportRentDto,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.post<ServerResponse>(
      `/api/report/registration/borrowed`,
      datas,
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const reportUpdateRent = async (
  reportId: number,
  datas: RegistrationReportRentDto,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.put<ServerResponse>(
      `/api/report/registration/borrowed/edit/${reportId}`,
      datas,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const reportRentDetail = async (
  reportId: number,
): Promise<ReportRentDetailDto> => {
  try {
    const response = await axiosInstance.get<ReportRentDetailDto>(
      `/api/report/registartion/borrowed/${reportId}`,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchTransactionBelonged = async (
  params: FetchReportParams,
): Promise<TransactionReportDtoRx> => {
  try {
    const {
      startDate,
      endDate,
      offset = 0,
      limit = 1000,
      sortBy = 'arrivedAt',
      order = 'desc',
      name,
      reportType,
    } = params;
    const response = await axiosInstance.get<TransactionReportDtoRx>(
      `/api/report/transaction/belonged`,
      {
        params: {
          startDate,
          endDate,
          offset,
          limit,
          sortBy,
          order,
          name,
          reportType,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchTransactionRent = async (
  params: FetchReportParams,
): Promise<TransactionReportDtoRx> => {
  try {
    const {
      startDate,
      endDate,
      offset = 0,
      limit = 1000,
      sortBy = 'arrivedAt',
      order = 'desc',
      name,
      reportType,
    } = params;
    const response = await axiosInstance.get<TransactionReportDtoRx>(
      `/api/report/transaction/borrowed`,
      {
        params: {
          startDate,
          endDate,
          offset,
          limit,
          sortBy,
          order,
          name,
          reportType,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};
